import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const LANGS = [
  { code: 'pt-BR', label: 'Português', short: 'PT' },
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'fr', label: 'Français', short: 'FR' }
];

// Seletor de idioma em dropdown. `paths` mapeia code -> rota equivalente
// na página atual (LOCALE_PATHS / GUIDE_PATHS / PARTNER_PATHS).
export function LangSwitcher({ lang, paths }: { lang: string; paths: Record<string, string> }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const current = LANGS.find((l) => l.code === lang) ?? LANGS[0];

  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [open]);

  return (
    <div className={`lang-dd${open ? ' is-open' : ''}`} ref={ref}>
      <button type="button" className="lang-dd__btn" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        <span aria-hidden="true" className="lang-dd__globe">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="9" /><path d="M3 12h18 M12 3c2.5 2.5 2.5 15 0 18 M12 3c-2.5 2.5-2.5 15 0 18" />
          </svg>
        </span>
        <span className="lang-dd__label">{current.short}</span>
        <span aria-hidden="true" className="lang-dd__caret">
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m6 9 6 6 6-6" /></svg>
        </span>
      </button>
      {open && (
        <ul className="lang-dd__menu" role="listbox">
          {LANGS.map((l) => (
            <li key={l.code} role="option" aria-selected={l.code === lang}>
              <button
                type="button"
                className={l.code === lang ? 'active' : ''}
                onClick={() => { setOpen(false); if (l.code !== lang) navigate(paths[l.code] ?? '/'); }}
              >
                <span className="lang-dd__menu-short">{l.short}</span>
                <span className="lang-dd__menu-name">{l.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
